import { useEffect, useState } from "react";
import MessageModal from "./MessageModal";

const MessageModalContainer=()=>{
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [modalType, setModalType] = useState("");

    // Event listener for the custom event
    useEffect(() => {
        const handleShowModal = (event) => {
            const { message, type } = event.detail; // Extract data from event detail
            setModalMessage(message);
            setModalType(type);
            setIsModalVisible(true);
        };

        // Add the event listener
        window.addEventListener("showMessageModal", handleShowModal);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("showMessageModal", handleShowModal);
        };
    }, []);

    return(
        <>
            {
                isModalVisible?
                    <MessageModal messageContent={modalMessage} messageType={modalType} closeFunc={setIsModalVisible}/>
                :
                    null
            }
        </>
    );
}

export default MessageModalContainer;